import _ from 'lodash'
import React from 'react'

import { Settings } from 'browser/app/models/settings'

import { AppNavigatorContext } from 'browser/contexts/app-navigator/app-navigator-context'

export function WithSettingsProps<P extends object>(
  WrappedComponent: React.ComponentType<P>,
  settingsMappings: Record<string, string>
) {
  return class extends React.Component<P> {
    public render() {
      return (
        <AppNavigatorContext.Consumer>
          {({settings}) => (
            <WrappedComponent
              {...this.getDefaultProperties(settings)}
              {...this.props}
            />
          )}
        </AppNavigatorContext.Consumer>
      )
    }

    private getDefaultProperties(settings: Settings) {
      const defaultProps: Record<string, unknown> = {}
      _.forEach(settingsMappings, (path, key) => {
        const pathArr = path.split('.')
        const namespace = pathArr[0]
        const property = pathArr.slice(1).join('.')
        defaultProps[key] = settings.getSettingsProperty(namespace, property)
      })
      return defaultProps
    }
  }
}
